module.exports = __webpack_public_path__ + "static/media/costcase7.ed8d6306.png";